import React from 'react';
import { Nav } from 'rsuite';

import './styles.css';

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').NavItemProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomToggle component.
 */

export function CustomNavItem({ children, icon, subtitle, ...rest }) {
  return (
    <Nav.Item {...rest} className="custom-navItem">
      <div className="custom-navItem-inner">
        {icon && <div className="custom-navItem-iconChip">{icon}</div>}
        <div className="custom-navItem-label">
          <div className="custom-navItem-labelMain">{children}</div>
          {subtitle && <div className="custom-navItem-labelSub">{subtitle}</div>}
        </div>
      </div>
    </Nav.Item>
  );
}
